import { z } from "zod";

export const CreditServiceSchema = z.object({
  amount: z.string().min(1, "Veuillez renseigner un montant."),
  reason: z.string().min(1, "Veuillez renseigner un motif.")
});

export type CreditServiceSchema = z.infer<typeof CreditServiceSchema>;
